<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-toggle auto-hide="false">
            <img src="../assets/svg/logo-toolbar.svg">
          </ion-menu-toggle>
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-button v-if="back" class="btn-back" @click="$router.go(-1)">Back</ion-button>
          <ion-button v-if="!back" class="btn-back" @click="$router.push({ name: 'new-yacht', params: { yacht_id: yacht.id, yacht_name: yacht.name } })">Back</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <bg :opaque="1"></bg>
      <ion-grid>
        <form @submit="save" class="mt-20">
          <ion-row class="row-boxed">
            <ion-col size-xs="12" size-md="6">
              <ion-input :disabled="$store.state.user_role == 'client' ? true : false" placeholder="Yacht name" :value="yacht.name" @ionInput="yacht.name = $event.target.value;"></ion-input>
            </ion-col>
            <ion-col size-xs="12" size-md="6">
              <ion-input :disabled="$store.state.user_role == 'client' ? true : false" placeholder="Length" :value="yacht.length" @ionInput="yacht.length = $event.target.value;"></ion-input>
            </ion-col>
            <ion-col size-xs="12" size-md="6">
              <ion-input :disabled="$store.state.user_role == 'client' ? true : false" placeholder="Beam" :value="yacht.beam" @ionInput="yacht.beam = $event.target.value;"></ion-input>
            </ion-col>
            <ion-col size-xs="12" size-md="6">
              <ion-input :disabled="$store.state.user_role == 'client' ? true : false" placeholder="Draft" :value="yacht.draft" @ionInput="yacht.draft = $event.target.value;"></ion-input>
            </ion-col>
            <ion-col size-xs="12" size-md="6">
              <ion-input :disabled="$store.state.user_role == 'client' ? true : false" placeholder="Gross Tonnage" :value="yacht.gross_tonnage" @ionInput="yacht.gross_tonnage = $event.target.value;"></ion-input>
            </ion-col>
            <ion-col size-xs="12" size-md="6">
              <ion-input :disabled="$store.state.user_role == 'client' ? true : false" placeholder="Maximum Speed" :value="yacht.max_speed" @ionInput="yacht.max_speed = $event.target.value;"></ion-input>
            </ion-col>
            <ion-col size-xs="12" size-md="6">
              <ion-input :disabled="$store.state.user_role == 'client' ? true : false" placeholder="Range at 10 knots" :value="yacht.range_10_knots" @ionInput="yacht.range_10_knots = $event.target.value;"></ion-input>
            </ion-col>
            <ion-col size-xs="12" size-md="6">
              <ion-input :disabled="$store.state.user_role == 'client' ? true : false" placeholder="Fuel Capacity" :value="yacht.fuel_capacity" @ionInput="yacht.fuel_capacity = $event.target.value;"></ion-input>
            </ion-col>
            <ion-col size-xs="12" size-md="6">
              <ion-input :disabled="$store.state.user_role == 'client' ? true : false" placeholder="Guests" :value="yacht.guests" @ionInput="yacht.guests = $event.target.value;"></ion-input>
            </ion-col>
            <ion-col size-xs="12" size-md="6">
              <ion-input :disabled="$store.state.user_role == 'client' ? true : false" placeholder="Cabins" :value="yacht.cabins" @ionInput="yacht.cabins = $event.target.value;"></ion-input>
            </ion-col>
            <ion-col size-xs="12" size-md="6">
              <ion-input :disabled="$store.state.user_role == 'client' ? true : false" placeholder="Crew" :value="yacht.crew" @ionInput="yacht.crew = $event.target.value;"></ion-input>
            </ion-col>
            <ion-col size-xs="12" size-md="6">
              <ion-input :disabled="$store.state.user_role == 'client' ? true : false" placeholder="Main Engines" :value="yacht.main_engines" @ionInput="yacht.main_engines = $event.target.value;"></ion-input>
            </ion-col>
            <ion-col size-xs="12" size-md="6">
              <ion-input :disabled="$store.state.user_role == 'client' ? true : false" placeholder="Generators" :value="yacht.generators" @ionInput="yacht.generators = $event.target.value;"></ion-input>
            </ion-col>
            <ion-col size-xs="12" size-md="6">
              <ion-input :disabled="$store.state.user_role == 'client' ? true : false" placeholder="Stabilisers" :value="yacht.stabilisers" @ionInput="yacht.stabilisers = $event.target.value;"></ion-input>
            </ion-col>
            <ion-col size-xs="12" size-md="6" v-if="$store.state.user_role != 'client'">
              <file-upload
                input-id="uploadImg"
                class="upload-btn"
                :post-action="upload"
                :data="{api_token: $store.state.api_token}"
                :multiple="true"
                :drop="true"
                :extensions="['jpg', 'jpeg', 'gif', 'png', 'webp']"
                :drop-directory="false"
                v-model="yatchImg"
                @input-file="inputYatchImg"
                ref="uploadImg">
                Add image
              </file-upload>
            </ion-col>
            <ion-col size-xs="12" size-md="6" v-if="yacht.img" class="text-left">
              <div class="yacht-img">
                <span @click="removeImg" v-if="$store.state.user_role != 'client'">-</span>
                <img :src="yacht.img">
              </div>
            </ion-col>
            <ion-col size="12" class="text-right" v-if="$store.state.user_role != 'client'">
              <ion-button type="submit">SAVE</ion-button>
            </ion-col>
          </ion-row>
          <!-- Permette l'invio del form con tasto enter -->
          <input type="submit" class="hidden">
        </form>

      </ion-grid>
      <loader :visible="loader"></loader>
    </ion-content>
  </ion-page>
</template>

<script>
import axios from "axios"
import Vue from "vue"
import FileUpload from 'vue-upload-component'
export default {
  name: "NewYachtSpecifications",
  components: {
    FileUpload,
  },
  data: function() {
    return {
      yacht: {
        id: this.$route.params.id,
        name: '',
        length: '',
        beam: '',
        draft: '',
        gross_tonnage: '',
        max_speed: '',
        range_10_knots: '',
        fuel_capacity: '',
        guests: '',
        cabins: '',
        crew: '',
        main_engines: '',
        generators: '',
        stabilisers: '',
      },
      upload: '',
      yatchImg: [],
      back: this.$route.params.back ? this.$route.params.back : false,
      loader: true,
    }
  },
  methods: {
    removeImg: function() {
      this.yacht.img = ''
    },
    async inputYatchImg(newFile, oldFile) {
      if (newFile && oldFile) {
        if (newFile.progress !== oldFile.progress) {
          this.loader = true;
        }
        if (newFile.error && !oldFile.error) {
          if (newFile.error && newFile.error == 'extension') {
            const toast = await this.$ionic.toastController.create({
              message: 'File not supported',
              color: 'danger',
              position: 'bottom',
              duration: 2000
            })
            await toast.present();
          }
        }
        if (newFile.success && !oldFile.success) {
          this.loader = false;
          this.yacht.img = newFile.response.file
          const toast = await this.$ionic.toastController.create({
            message: 'Image added succesfully',
            color: 'success',
            position: 'bottom',
            duration: 2000
          })
          await toast.present();
        }
      }

      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.uploadImg.active) {
          this.$refs.uploadImg.active = true
        }
      }
    },
    save(ev) {
      ev.preventDefault();
      this.loader = true;
      axios.post(this.apiUrl + '/api/v1/save-yacht', { api_token: this.$store.state.api_token, yacht: this.yacht })
      .then(async(response) => {
        let res = response.data
        if(res.data) {
          const toast = await this.$ionic.toastController.create({
            message: 'Yacht updated succesfully',
            color: 'success',
            position: 'bottom',
            duration: 2000
          })
          await toast.present();
        }
        this.loader = false;
      })
    }
  },
  mounted: function() {
    this.upload = this.apiUrl + '/api/v1/upload';

    axios.post(this.apiUrl + '/api/v1/get-yacht', { api_token: this.$store.state.api_token, id: this.yacht.id })
    .then((response) => {
      let res = response.data
      if(res.data) {
        Vue.set(this.yacht, 'name', res.data.name);
        Vue.set(this.yacht, 'length', res.data.length);
        Vue.set(this.yacht, 'beam', res.data.beam);
        Vue.set(this.yacht, 'draft', res.data.draft);
        Vue.set(this.yacht, 'gross_tonnage', res.data.gross_tonnage);
        Vue.set(this.yacht, 'max_speed', res.data.max_speed);
        Vue.set(this.yacht, 'range_10_knots', res.data.range_10_knots);
        Vue.set(this.yacht, 'fuel_capacity', res.data.fuel_capacity);
        Vue.set(this.yacht, 'guests', res.data.guests);
        Vue.set(this.yacht, 'cabins', res.data.cabins);
        Vue.set(this.yacht, 'crew', res.data.crew);
        Vue.set(this.yacht, 'main_engines', res.data.main_engines);
        Vue.set(this.yacht, 'generators', res.data.generators);
        Vue.set(this.yacht, 'stabilisers', res.data.stabilisers);
        Vue.set(this.yacht, 'img', res.data.img);
      }
      this.loader = false;
    })
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.yacht-img {
  position: relative;
  display: inline-block;
}

.yacht-img span {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 20px;
  height: 20px;
  background-color: var(--ion-color-primary);
  border-radius: 4px;
  color: #fff;
  text-align: center;
  cursor: pointer;
}

.yacht-img img {
  max-width: 100px;
}
</style>